export const AppSvgIcons = {
  html5_icon: 'assets/icons/html5_icon.svg',
  zip_icon: 'assets/icons/zip_icon.svg',
  image_icon: 'assets/icons/image_icon.svg',
  video_icon: 'assets/icons/video_icon.svg',
  powerpoint_icon: 'assets/icons/powerpoint_icon.svg',
  pdf_icon: 'assets/icons/pdf_icon.svg',
  audio_icon: 'assets/icons/audio_icon.svg',
  file_icon: 'assets/icons/file_icon.svg',
  briefcase: 'assets/icons/briefcase.svg',
  msteams: 'assets/icons/microsoft-teams.svg',
  building: 'assets/icons/building.svg',
  pdf: 'assets/icons/pdf.svg',
  doc: 'assets/icons/doc.svg',
  ppt: 'assets/icons/ppt.svg',
  xlsx: 'assets/icons/xlsx.svg',
  'freeze-columns': 'assets/icons/freeze-columns.svg',
  'wide-short-text': 'assets/icons/wide-short-text.svg',
  'fit-wrapped-text': 'assets/icons/fit-wrapped-text.svg',
  'fit-short-text': 'assets/icons/fit-short-text.svg',
  'extra-wide-full-text': 'assets/icons/extra-wide-full-text.svg',
  dashboard_menu_icon: 'assets/icons/dashboard_menu_icon.svg',
  projects_menu_icon: 'assets/icons/projects_menu_icon.svg',
  tasks_menu_icon: 'assets/icons/tasks_menu_icon.svg',
  planning_menu_icon: 'assets/icons/planning_menu_icon.svg',
  overview_menu_icon: 'assets/icons/overview_menu_icon.svg',
  companies_menu_icon: 'assets/icons/companies_menu_icon.svg',
  groups_menu_icon: 'assets/icons/groups_menu_icon.svg',
  users_menu_icon: 'assets/icons/users_menu_icon.svg',
  teams_menu_icon: 'assets/icons/teams_menu_icon.svg',
  taxonomy_menu_icon: 'assets/icons/taxonomy_menu_icon.svg',
  listview: 'assets/icons/listview.svg',
  gridview_small: 'assets/icons/gridview_small.svg',
  gridview_large: 'assets/icons/gridview_large.svg',
  maintenance_icon: 'assets/icons/maintenance_icon.svg',
};
